import { GeneralLoanWaiverService } from '@/modules/global-settings/loan-origination/services/security-policies/loan-waiver.service';
import { make } from 'vuex-pathify';
import Logger from '@/lib/logger';
// Create a new instance of the GeneralLoanWaiverService class
const generalLoanWaiverService = new GeneralLoanWaiverService();

// Define the state of the module
export const state = {
  generalLoanWaiverSettings: [],
  waiverNames: [
    'Amount',
    'Interest',
    'Tenure',
    'Debt Service Ratio',
    'Share',
    'Collateral Value',
    'Service Charge'
  ]
};

// Define the mutations of the module
export const mutations = {
  ...make.mutations(state)
};
// Define the actions of the module
export const actions = {
  /**
   * Fetches the general loan waiver settings
   * @async
   * @param {object} commit - vuex commit
   * @returns {Array} data - array of general loan waiver settings
   * @private This will set the state of the general loan waiver settings
   */
  getGeneralLoanWaiverSettings: async ({ commit }) => {
    try {
      const { data } =
        await generalLoanWaiverService.getGeneralLoanWaiverSettings();
      commit('SET_GENERAL_LOAN_WAIVER_SETTINGS', data);
      return data;
    } catch (error) {
      Logger.error('getting general loan waiver settings', error);
      throw error;
    }
  },
  /**
   * Fetches the general loan waiver setting by id
   * @async
   * @param {object} commit - vuex commit
   * @param {number} id - id of the general loan waiver setting
   * @returns {object} data - general loan waiver setting
   */
  getGeneralLoanWaiverSetting: async (_, id) => {
    try {
      const { data } =
        await generalLoanWaiverService.getGeneralLoanWaiverSetting(id);
      return data;
    } catch (error) {
      Logger.error('getting general loan waiver settings', error);
      throw error;
    }
  },
  /**
   * Creates a new general loan waiver setting
   * @async
   * @param {object} dispatch - vuex dispatch
   * @returns {object} data - general loan waiver setting
   * @private This will dispatch the getGeneralLoanWaiverSettings action
   */
  createGeneralLoanWaiverSetting: async ({ dispatch }) => {
    try {
      const { data } =
        await generalLoanWaiverService.createGeneralLoanWaiverSetting();
      dispatch('getGeneralLoanWaiverSettings');
      return data;
    } catch (error) {
      Logger.error('creating general loan waiver settings', error);
      throw error;
    }
  },
  /**
   * Updates a general loan waiver setting
   * @async
   * @param {object} dispatch - vuex dispatch
   * @param {object} payload - payload to be updated
   * @returns {void}
   * @private This will dispatch the getGeneralLoanWaiverSettings action
   */
  updateGeneralLoanWaiverSetting: async ({ dispatch }, payload) => {
    try {
      await generalLoanWaiverService.updateGeneralLoanWaiverSetting(payload);
      dispatch('getGeneralLoanWaiverSettings');
    } catch (error) {
      Logger.error('updating general loan waiver settings', error);
      throw error;
    }
  },
  /**
   * Updates the level active state
   * @async
   * @param {object} dispatch - vuex dispatch
   * @param {object} payload - payload to be updated
   * @returns {void}
   * @private This will dispatch the getGeneralLoanWaiverSettings action
   */
  updateLevelActive: async ({ dispatch }, payload) => {
    try {
      await generalLoanWaiverService.updateLevelActive(payload);
      dispatch('getGeneralLoanWaiverSettings');
    } catch (error) {
      Logger.error('updating level active loan waiver settings', error);
      throw error;
    }
  }
};

// Define the getters of the module
export const getters = make.getters(state);
